jQuery(function($){
    var ProjectName = {
        init: function () {
            this.win = $(window);
            this.html = $('body');
            this.myEventItem = $('class');
            this.print = $('.print');
            this.btnToggleNav = $('#nav-toggle');
            this._bindEvent();
        },
        _bindEvent: function() {
            ProjectName.myEventItem.on('click', function(e){
                ProjectName._myEvent(e);
            });
            ProjectName.btnToggleNav.on('click', function (e) {
                ProjectName._toggleNav(e);
            });
        },
        _myEvent: function (e) {
            e.stopPropagation();
            return false;
        },
        _toggleNav: function (e) {
            e.stopPropagation();
            if (ProjectName.html.hasClass('navigation-open')) {
                ProjectName.html.removeClass('navigation-open');
                
                ProjectName.btnToggleNav.attr("aria-expanded","false");
            } else {
                ProjectName.html.addClass('navigation-open');
                
                ProjectName.btnToggleNav.attr("aria-expanded","true");
            }
        },
        _webfont: function () {
            WebFont.load({
                google: {
                    families: ['Montserrat','Open Sans']
                }
            });
        }
    }

    function animateCss(element, animationName, callback) {
        const node = document.querySelector(element)
        node.classList.add('animated', animationName)

        function handleAnimationEnd() {
            node.classList.remove('animated', animationName)
            node.removeEventListener('animationend', handleAnimationEnd)

            if (typeof callback === 'function') callback()
        }

        node.addEventListener('animationend', handleAnimationEnd)
    }

    $(document).ready(function () {
        ProjectName.init();

        $('#home-slider').bxSlider({
            mode: 'fade',
            easing: 'ease',
            auto: 'true',
            speed   : 4000,
            pager   : false,
            //controls   : false,
            pause   : 4000,
            autoDelay : 2000,
        });

        //animateCss('.animation-left', 'slideInLeft');
        //animateCss('.animation-right', 'slideInRight');
        //animateCss('.animation-up', 'slideInUp');

        $('body').addClass('show');

        $('.gallery-item').featherlightGallery({
            previousIcon: '',
            nextIcon: '',
            galleryFadeIn: 300,
            openSpeed: 300,
        });
    });
});
